import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      {/* <div className='w-full py-[0.4px] bg-gradient-to-r from-[#111111] via[#242424] to-[#dfdfdf] mt-32'></div> */}
      <div className="my-5">
        <div className="mx-0 py-[0.4px] 2xl:py-[0.7px] bg-gradient-to-r from-[#060606] via-[#848484] to-[#060606] mb-3"></div>
        <div className="text-center xs:flex space-y-2 xs:space-y-0 w-full xs:justify-between leading-10 text-slate-400 pb-6 sm:pb-0">
          <div className="text-xs sm:text-sm font-sans">
            © 2025. Tracklimo Pvt Ltd. All rights reserved.
          </div>
          <div className="text-center flex items-center justify-center xs:justify-end space-x-4 md:space-x-10 xs:space-y-0 text-xs sm:text-sm font-sans">
            <Link to="/TermsConditions">Terms and Conditions</Link>
            <Link to="/PrivacyPolicy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
